import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Bowser from 'bowser';

import DefaultRoutes from 'routes';
import SplashScreen from 'components/app/splash';
import GettingStartedModal from 'components/app/getting-started';
import { CloseButton } from 'components/common/Toast';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'leaflet-geosearch/dist/geosearch.css';

import { setConfig } from 'reducers/configReducer';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const { navbarPosition } = useSelector(state => state.config);
  const browser = Bowser.getParser(window.navigator.userAgent);
  const { showSplash, showGettingStarted } = useSelector(state => state.config);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setConfig({
        key: 'showSplash',
        value:
          localStorage.getItem('showSplashAtLogin') === 'true' ? true : false
      })
    );
    dispatch(
      setConfig({
        key: 'showSplashAtLogin',
        value:
          localStorage.getItem('showSplashAtLogin') === 'true' ? true : false
      })
    );
  }, []);

  useEffect(() => {
    if (browser.getOS().name === 'Windows') {
      HTMLClassList.add('windows');
    }

    // Adding classes based on the browser
    const browserName = browser.getBrowserName();

    switch (browserName) {
      case 'Chrome':
        HTMLClassList.add('chrome');
        break;
      case 'Firefox':
        HTMLClassList.add('firefox');
        break;
      case 'Safari':
        HTMLClassList.add('safari');
        break;
      default:
        // Handle other browsers or no action required
        break;
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <DefaultRoutes />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
      <SplashScreen
        show={showSplash}
        onClose={() => dispatch(setConfig({ key: 'showSplash', value: false }))}
      />
      <GettingStartedModal
        show={showGettingStarted}
        onClose={() =>
          dispatch(setConfig({ key: 'showGettingStarted', value: false }))
        }
      />
    </Router>
  );
};

export default App;
